import { KoobInputSelect, KoobInputLabel } from '@koob/ui';
import { useField } from 'formik';
import { isObject } from 'lodash';
import { FormField, ErrorMessageWrapper } from 'ui/forms';

const SelectField = ({
  label,
  onAfterSelect,
  handleChangeCity,
  touchRequired = true,
  required,
  searchable,
  ...props
}) => {
  const [field, meta, { setValue, setTouched }] = useField(props);

  const hasError =
    (!touchRequired || Boolean(meta.touched)) && Boolean(meta.error);
  const options = props.options ?? [];

  return (
    <FormField>
      {label && <KoobInputLabel label={label} required={required} />}

      <KoobInputSelect
        options={options}
        value={field.value?.value ?? field.value}
        disabled={props.disabled}
        placeholder={props.placeholder}
        searchable={searchable}
        error={hasError}
        data-testid={props.testId}
        onValueChange={v => {
          const value = options.find(option => option.value === v) ?? v;
          setValue(value);
          if (Boolean(handleChangeCity)) {
            handleChangeCity(value);
          }
          setTimeout(() => setTouched(true, true));
          if (Boolean(onAfterSelect)) {
            onAfterSelect(value?.value);
          }
        }}
        renderOption={
          props.renderOption ? option => props.renderOption(option) : undefined
        }
        renderValue={props.renderSelectedValue}
      />
      {hasError && (
        <ErrorMessageWrapper>
          {isObject(meta.error) ? meta.error?.value : meta.error}
        </ErrorMessageWrapper>
      )}
    </FormField>
  );
};

export default SelectField;
